import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { Spinner } from "@/components/ui/spinner";
import { installConsoleErrorBuffer } from "@/shared/lib/console-error-buffer";
import { routeTree } from "./routeTree.gen";
import "./index.css";

// 제보에 첨부할 클라이언트 에러를 앱 시작 시점부터 모은다
installConsoleErrorBuffer();

function DefaultPending() {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <Spinner className="size-4 animate-spin" />
    </div>
  );
}

const router = createRouter({
  routeTree,
  defaultPendingComponent: DefaultPending,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
